
export class CheckboxFilterLocalizationsModel {
    selectAll: string = 'Select All';
    selectNone: string = 'Select None';
}
